<div class="full-image-modal modal fade text-left modal-borderless" id="full-image-modal" tabindex="-1" role="dialog"
    aria-labelledby="Modal pesaje" aria-hidden="true" #fullImageModal>
    <div class="modal-dialog modal-dialog-scrollable modal-full" role="document">
        <div class="modal-content">
            <div class="modal-header pb-0">
                <h5 class="modal-title"></h5>
                <button type="button" class="close rounded-pill" data-bs-dismiss="modal" aria-label="Close">
                    <span class="material-symbols-outlined pt-1">close</span>
                </button>
            </div>
            <div class="modal-body pt-0">
                <img [src]="urlImage" alt="" class="img-fluid modal-img">
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-light-primary" data-bs-dismiss="modal">
                    <span class="material-symbols-outlined">keyboard_return</span>
                    <span class="d-none d-sm-block">Cerrar</span>
                </button>
            </div>

        </div>
    </div>
</div>

